import { render, staticRenderFns } from "./PasienRawatDetail.vue?vue&type=template&id=927eb536"
import script from "./PasienRawatDetail.vue?vue&type=script&lang=js"
export * from "./PasienRawatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927eb536')) {
      api.createRecord('927eb536', component.options)
    } else {
      api.reload('927eb536', component.options)
    }
    module.hot.accept("./PasienRawatDetail.vue?vue&type=template&id=927eb536", function () {
      api.rerender('927eb536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/PasienRawatDetail.vue"
export default component.exports